import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth.ts'
import { appPath, stripAppBase } from '../../appConfig.ts'

export function Header() {
  const { user, logout } = useAuth()
  const pathname = stripAppBase(useLocation().pathname)

  return (
    <header className="h-12 bg-gray-800 text-white flex items-center justify-between px-4 shrink-0">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-3">
          <h1 className="text-sm font-semibold tracking-wide">
            Network Topology Platform
          </h1>
          <span className="text-xs text-gray-400">Logan Light & Power</span>
        </div>

        <nav className="flex items-center gap-1">
          <Link
            to={appPath('/')}
            className={`text-xs px-3 py-1 rounded transition-colors ${
              pathname === '/'
                ? 'bg-gray-700 text-white'
                : 'text-gray-400 hover:text-white hover:bg-gray-700'
            }`}
          >
            Home
          </Link>
          <Link
            to={appPath('/map')}
            className={`text-xs px-3 py-1 rounded transition-colors ${
              pathname === '/map'
                ? 'bg-gray-700 text-white'
                : 'text-gray-400 hover:text-white hover:bg-gray-700'
            }`}
          >
            Map
          </Link>
          <Link
            to={appPath('/outages')}
            className={`text-xs px-3 py-1 rounded transition-colors ${
              pathname === '/outages' ||
              pathname.startsWith('/outages/')
                ? 'bg-gray-700 text-white'
                : 'text-gray-400 hover:text-white hover:bg-gray-700'
            }`}
          >
            Outages
          </Link>
          <Link
            to={appPath('/engineering')}
            className={`text-xs px-3 py-1 rounded transition-colors ${
              pathname === '/engineering'
                ? 'bg-gray-700 text-white'
                : 'text-gray-400 hover:text-white hover:bg-gray-700'
            }`}
          >
            Engineering
          </Link>
          <Link
            to={appPath('/secondary-review')}
            className={`text-xs px-3 py-1 rounded transition-colors ${
              pathname === '/secondary-review'
                ? 'bg-gray-700 text-white'
                : 'text-gray-400 hover:text-white hover:bg-gray-700'
            }`}
          >
            Secondary Review
          </Link>
          <Link
            to={appPath('/discrepancies')}
            className={`text-xs px-3 py-1 rounded transition-colors ${
              pathname === '/discrepancies'
                ? 'bg-gray-700 text-white'
                : 'text-gray-400 hover:text-white hover:bg-gray-700'
            }`}
          >
            Discrepancies
          </Link>
          {/* GIS Phase 2A: capability-gated (spec §2 — hiding is cosmetic,
              the route itself still enforces gis.queue.view server-side). */}
          {user?.capabilities?.includes('gis.queue.view') && (
            <Link
              to={appPath('/gis-queue')}
              className={`text-xs px-3 py-1 rounded transition-colors ${
                pathname === '/gis-queue'
                  ? 'bg-gray-700 text-white'
                  : 'text-gray-400 hover:text-white hover:bg-gray-700'
              }`}
            >
              GIS Queue
            </Link>
          )}
        </nav>
      </div>

      <div className="flex items-center gap-4">
        {user && (
          <>
            {user.is_admin && (
              <Link
                to={appPath('/admin/users')}
                className={`text-xs px-3 py-1 rounded transition-colors ${
                  pathname.startsWith('/admin/')
                    ? 'bg-gray-700 text-white'
                    : 'text-gray-400 hover:text-white hover:bg-gray-700'
                }`}
              >
                Users
              </Link>
            )}
            <Link
              to={appPath('/account')}
              className={`text-xs px-3 py-1 rounded transition-colors ${
                pathname === '/account'
                  ? 'bg-gray-700 text-white'
                  : 'text-gray-400 hover:text-white hover:bg-gray-700'
              }`}
            >
              {user.full_name || user.username}
            </Link>
            <button
              onClick={logout}
              className="text-xs text-gray-400 hover:text-white transition-colors"
            >
              Sign out
            </button>
          </>
        )}
      </div>
    </header>
  )
}
